//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 22.07.2015.
 */

(function () {

    'use strict';

    angular.module('container.layout')
        .directive('srsngHeader', srsngHeader);

    function srsngHeader($rootScope, $compile, headerService, Localization, Event, userSettingsService, authenticationService) {

        return {
            restrict: 'E',
            scope: {},
            templateUrl: 'container/ui/app/layout/header/header.html',
            controller: controller,
            link: link
        };

        function controller($scope, $translate, $translatePartialLoader) {

            Localization.loadSupportedLanguages();

            $scope.userDisplayName = '';
            $scope.userPicture = undefined;

            $rootScope.$on(Event.USER_LOGGED_IN, function(evt) {
                if (authenticationService.profile) {
                    $scope.userDisplayName = `${authenticationService.profile.firstName} ${authenticationService.profile.lastName}`;
                }
            });

            $scope.logout = function() {
                authenticationService.logout();
            };

            $scope.languageList = {
                visible: false
            };

            $scope.toggleLanguageList = function () {                
              $scope.languageList.visible = !$scope.languageList.visible;
            };

            $scope.shareBox = {
                visible: false
            };

            $scope.toggleShareBox = function ($event) {
                $scope.shareBox.visible = !$scope.shareBox.visible;
            };

            $scope.runningTasks = {
                visible: false
            };

            $scope.loginPanel = {
                visible: false
            };

            $scope.toggleRunningTasks = function ($event) {
                $scope.runningTasks.visible = !$scope.runningTasks.visible;
            };

            $scope.clipboard = {
                visible: false
            };

            $scope.toggleClipboard = function ($event) {
                $scope.clipboard.visible = !$scope.clipboard.visible;
            };

            $scope.searchMenu = {
                visible: false
            };

            $scope.toggleSearchMenu = function ($event) {
                $scope.searchMenu.visible = !$scope.searchMenu.visible;
            };

            $scope.timeZone = {
                visible: false,
                date: new Date()
            };

            $scope.toggleTimeZone = function($event) {
                $scope.timeZone.visible = !$scope.timeZone.visible;
            };

            $scope.userProfile = {
                visible: false                
            };

            $scope.toggleUserProfile = function($event) {
                $scope.userProfile.visible = !$scope.userProfile.visible;
            }

            $scope.softwareInfo = {
                visible: false                
            };

            $scope.toggleSoftwareInfo = function($event) {
                $scope.softwareInfo.visible = !$scope.softwareInfo.visible;
            }

            // init()

            // function init() {
                // initUserPicture();
                // $rootScope.$on('userProfile:userPictureChanged', initUserPicture);
                // $rootScope.$on(Event.USER_LOGGED_IN, initUserPicture);
            // }

            
            // function initUserPicture() {
            //     if ($scope.user) {
            //         let updatePromise = userSettingsService.getUserPicture($scope.user.userName)
            //             .then(image => {                    
            //                 $scope.userPicture = image.binaryData;
            //             }, () => {
            //                 console.log('userPicture is not set');
            //             });
            //         $rootScope.$emit('handleBusyPromise', updatePromise);
            //     }
            // }
        }

        function link(scope, element, attrs) {

            $rootScope.$on('headerService:componentsChanged', getComponents);

            var container = element.find('.extension-components');

            function getComponents() {

                container.empty();

                headerService.getComponents().forEach(function (component) {

                    var element = $compile(component.markup)($rootScope.$new());
                    element.data('id', component.id);
                    element.appendTo(container);
                });
            }
        }

    }

}());

